export const deviceType = Object.freeze({
  POS_MACHINE: 'POS_MACHINE',
  POS_USER_MOBILE: 'POS_USER_MOBILE',
  ONLINE: 'ONLINE',
});



// WEBPACK FOOTER //
// ./utils/deviceType.js